import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import PaperWrapper from "../../../../Component/UI/PaperWrapper/PaperWrapper";
import { useEffect } from "react";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const Active = () => {};
  useEffect(() => {
    Active();
  }, [props.active]);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BasicTab = ({ ComponentName, btnApi, tag, selectedTabID, active }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let arr = Object.keys(btnApi[0]);
  useEffect(() => {
    selectedTabID?.(arr[value]);
  }, [value]);

  const ContentTag = tag ? "div" : PaperWrapper;
  return (
    <div style={{ width: "100%" }}>
      <Box sx={{ borderColor: "divider", padding: 1 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            sx: { color: "#3592FF", backgroundColor: "#3592FF", hidden: true },
          }}
          sx={{
            "& button": { color: "#000;", textTransform: "Capitalize" },
            "& button:hover": { color: "#000;" },
            "& button:active": { color: "#3592FF;" },
            "& button:focus": { color: "#3592FF;" },
            "& button.Mui-selected": { color: "#3592FF;" },
          }}
        >
          {Object.keys(btnApi[0]).map((keyResult) =>
            btnApi?.map((result, id) => (
              <Tab
                label={result[keyResult]}
                {...a11yProps({ keyResult })}
                key={id}
                disableRipple
              />
            ))
          )}
        </Tabs>
      </Box>
      {ComponentName.map((res, id) => {
        return (
          <TabPanel key={id} value={value} index={id}>
            {res}
          </TabPanel>
        );
      })}
    </div>
  );
};

export default BasicTab;
